import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { filter, take } from 'rxjs/operators';

import { OidcSecurityService, PublicEventsService, EventTypes } from 'angular-auth-oidc-client';

import { AlertService } from '../../shared-services/services/alert.service';
import { SecurityService } from 'src/app/shared-services/services/security.service';
import { StartStoreInfoModel } from 'src/app/shared-services/models/stores.model';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html'
})
export class NavbarComponent implements OnInit {

    isCollapsed = true;
    isAuthenticated: boolean;
    userData: any;

    private _data: StartStoreInfoModel;

    @Input() set data(value: StartStoreInfoModel) {
        console.log('data set', value);
        if (value === null || value === undefined) {
            return;
        } else {
            this._data = value;
        }
    }
    get data(): StartStoreInfoModel {
        return this._data;
    }

    constructor(
        private router: Router,
        public oidcSecurityService: OidcSecurityService,
        private alertService: AlertService,
        public securityService: SecurityService,
        private eventService: PublicEventsService) {

        console.log('NavbarComponent Constructor', securityService.currentCountryCode);
    }

    ngOnInit() {
        this.oidcSecurityService.checkAuthIncludingServer().subscribe(auth => {
            this.isAuthenticated = auth;
            console.log('Is Authenticated: ' + (auth ? 'Yes' : 'No'));
        });
        // Listen for the session change event, and if you see it...
        // make the user re-authorize?
        this.eventService
            .registerForEvents()
            .pipe(filter((notification) => notification.type === EventTypes.CheckSessionReceived))
            .subscribe((data) => {
                if ('changed' === data.value) {
                    this.oidcSecurityService.authorize();
                }
            });

        this.oidcSecurityService.userData$.subscribe(userData => {
            this.userData = userData;
            console.log('User Data:');
            console.log(userData);
            console.log('Id Token');
            console.log(this.oidcSecurityService.getIdToken());
        });
    }

    logout() {
        console.log('Logout');
        this.oidcSecurityService.logoff();
    }
}
